import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

/**
 * Call to action — src/Design/industries/industry-*.html, SECTION 7.
 * The page's own hero photo again, at low opacity, behind a heading +
 * detail line on the left and one button on the right.
 */
const CtaBanner = ({ heading, detail, ctaHref, ctaLabel, backgroundImage }) => {
  const isExternal = /^https?:\/\//.test(ctaHref)

  return (
    <section className="icta">
      {backgroundImage && (
        <GatsbyImage image={backgroundImage} alt="" loading="lazy" className="icta__bg" />
      )}
      <div className="icta__inner">
        <div>
          <h2 className="icta__heading">{heading}</h2>
          <p className="icta__detail">{detail}</p>
        </div>
        {isExternal ? (
          <a href={ctaHref} target="_blank" rel="noopener noreferrer" className="icta__btn">
            {ctaLabel}
          </a>
        ) : (
          <Link to={ctaHref} className="icta__btn">
            {ctaLabel}
          </Link>
        )}
      </div>
    </section>
  )
}

export default CtaBanner
